// @flow
import * as R from "ramda"

type Path = string | number | Array<string | number>
type Value = *
type Input = *

const set = R.curry((path: Path, value: Value, input: Input) => {
  // $FlowIssue
  const pathArr: Array<string | number> = Array.isArray(path) ? path : String(path).split(".")
  const lens = R.lensPath(pathArr)

  return R.set(lens, value, input)
})

export default set
